import React from "react";
import { Text, colors } from "ui-components";

import { HeaderWrapper } from "./styled";

const ContentHeader = ({ children }) => {
  return (
    <HeaderWrapper>
      <Text type="medium" size={4} color={colors.white}>
        {children}
      </Text>
    </HeaderWrapper>
  );
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/common/components/ContentHeader/ContentHeader.jsx